import { configureStore } from "@reduxjs/toolkit";
import loginReducer from "../features/login/login-slice";
import webReducer from "../features/web/web-slice";

export const store = configureStore({
	reducer: {
		login: loginReducer,
		web: webReducer,
	},
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
